import { IScheduledStreamContentBulkFailedItemQuery } from '../interfaces/scheduled-stream-content-bulk-failed-item.query.interface';

export class ScheduledStreamContentFailedItem {
    posting: { id: number };
    message: string;

    constructor(query: IScheduledStreamContentBulkFailedItemQuery) {
        this.posting = { id: query.posting.id };
        this.message = query.message;
    }
}
